export enum RiskRegisterGroupBy {
    None = "None",
    OrganizationLevel = "OrganizationLevel",
}
